import { useHistory } from "react-router-dom";
import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { Integration } from "../../../../models/Entities";
import { colorForAPICategory } from "../../../../models/Categories";
import { AvatarSize, IntegrationAvatar } from "../../../shared/MergeAvatars";
import { getBlueprintsPath, navigateHelper } from "../../../../router/RouterUtils";
import { getCategoryStatusBadgeText, isCategoryStatusVisible } from "../utils/categoryStatus";

type Props = {
  integration: Integration;
};

const IntegrationsDashboardGridCard = ({ integration }: Props) => {
  // hooks
  const history = useHistory();

  // derived state
  const visibleCategoryStatuses = (integration.categories_status_info ?? []).filter(
    isCategoryStatusVisible
  );

  // event handlers
  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    navigateHelper(history, getBlueprintsPath(integration.id), event.metaKey || event.ctrlKey);
  };

  // render
  return (
    <div
      className="flex w-32 cursor-pointer flex-col items-center gap-2 transition-transform hover:scale-105"
      onClick={onClick}
    >
      {/* The child selector overrides the avatar's own size classes without !important */}
      <div className="[&>div]:h-32 [&>div]:w-32">
        <IntegrationAvatar integration={integration} size={AvatarSize.xxl} />
      </div>
      <Text variant="sm" className="text-center">
        {integration.name}
      </Text>
      {visibleCategoryStatuses.length > 0 && (
        <div className="flex flex-wrap justify-center gap-1">
          {visibleCategoryStatuses.map((statusInfo) => (
            <Badge
              key={statusInfo.category}
              size="sm"
              color={colorForAPICategory(statusInfo.category)}
            >
              {getCategoryStatusBadgeText(statusInfo)}
            </Badge>
          ))}
        </div>
      )}
      {/* Active, non-test, fully linked accounts that do not need a relink */}
      <Text variant="sm" className="text-center text-gray-40">
        Linked Accounts: {integration.number_of_linked_accounts ?? 0}
      </Text>
    </div>
  );
};

export default IntegrationsDashboardGridCard;
